module.exports = __webpack_public_path__ + "img/freefooter-en.7086d4b9.png";